<template>
  <div
    id="app"
    v-bind:class="{
      logged: isLogged,
      history: historyLinkActive,
      home: homeLinkActive
    }"
  >
    <nav v-if="isLogged">
      <div class="container">
        <button v-on:click="back" class="back" v-if="backShow">
          <BackIcon />
        </button>
        <img alt="GPS Dozor logo" src="./assets/logo-small.png" class="logo" />
        <div class="navigation">
          <button class="opener" v-on:click="toggleNavigation">
            <MenuIcon />
          </button>
          <ul v-bind:class="{ show: showNavigation }">
            <li>
              <button
                v-if="controlLinkShow"
                v-on:click="controlLink"
                class="button-link"
                v-bind:class="{ active: controlLinkActive }"
              >
                Ověření jednotky
              </button>
            </li>
            <li>
              <button
                v-on:click="historyLink"
                class="button-link"
                v-bind:class="{ active: historyLinkActive }"
              >
                Historie montáží
              </button>
            </li>
            <li>
              <button
                v-on:click="instructionsLink"
                class="button-link"
                v-bind:class="{ active: instructionsLinkActive }"
              >
                Návody
              </button>
            </li>
            <li>
              <button v-on:click="logout" class="button-link">
                Odhlásit se
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="view">
      <router-view />
    </div>

    <Loading v-bind:visible="loadingVisible" />
  </div>
</template>

<script>
// @ is an alias to /src
import Loading from "@/components/Loading.vue";
import BackIcon from "@/icons/BackIcon.vue";
import MenuIcon from "@/icons/MenuIcon.vue";
import store from "./store";
import sendMessage from "./utils/functions";
import moment from "moment";

export default {
  name: "App",
  components: {
    Loading,
    BackIcon,
    MenuIcon
  },
  data: function() {
    return {
      showNavigation: false
    };
  },
  mounted() {
    store.commit("loadState");
    this.checkLogin();
    document.title = "GPS Dozor Servis";
  },
  computed: {
    isLogged() {
      return !(store.state.hash === null);
    },
    loadingVisible() {
      return store.state.loadingVisible;
    },
    backShow() {
      if (this.$route.name == "Check") return true;
      if (this.$route.name == "Save") return true;
      return false;
    },
    controlLinkActive() {
      if (
        this.$route.name === "Home" ||
        this.$route.name === "Check" ||
        this.$route.name === "Save" ||
        this.$route.name === "Finish"
      ) {
        return true;
      }
      return false;
    },
    historyLinkActive() {
      if (this.$route.name === "History") {
        return true;
      }
      return false;
    },
    homeLinkActive() {
      if (this.$route.name === "Home") {
        return true;
      }
      return false;
    },
    controlLinkShow() {
      if (store.state.role == 2) {
        return false;
      }
      return true;
    },
    instructionsLinkActive() {
      if (this.$route.name === "Instructions") {
        return true;
      }
      return false;
    }
  },
  methods: {
    checkLogin: function() {
      if (store.state.hash === null && window.location.pathname != "/login") {
        this.$router.push("login");
        return;
      }
    },
    logout: async function() {
      this.toggleNavigation();
      store.commit("showLoading");
      const result = await store.dispatch("logout");
      store.commit("hideLoading");

      sendMessage(`token:null`);

      if (result) {
        store.commit("saveState");
        this.$router.push("login");
      } else {
        store.commit("resetState");
        store.commit("saveState");
        this.$router.push("login");
      }
    },
    back: function() {
      this.$router.back();
    },
    controlLink: function() {
      this.toggleNavigation();
      this.$router.push("/");
    },
    historyLink: function() {
      this.toggleNavigation();
      this.$router.push("history");
    },
    instructionsLink: function() {
      this.toggleNavigation();
      this.$router.push("instructions");
    },
    toggleNavigation: function() {
      this.showNavigation = !this.showNavigation;
    }
  }
};
</script>

<style lang="less">
@import "./assets/less/global";

#app.history {
  padding-top: 66px;
  align-items: flex-start;
  padding: 66px 0 20px;
}

#app.home {
  align-items: center;
}

@media (min-width: 480px) {
  #app.history {
    width: 100%;

    nav {
      .container {
        width: 100%;
        max-width: 100%;
      }
    }
  }
}
</style>
